export default __webpack_public_path__ + "4b9de56ed8f91bf1dc05974f3626959a.png";